import React from "react";
import WarehouseGridMotif from "./WarehouseGridMotif";

interface AuthBrandPanelProps {
  badge: string;
  heading: string;
  subtext: string;
  children?: React.ReactNode;
}

// The indigo gradient brand panel shared by Login/Register (desktop-only,
// matches the app's own responsive breakpoint for hiding it).
const AuthBrandPanel: React.FC<AuthBrandPanelProps> = ({
  badge,
  heading,
  subtext,
  children,
}) => {
  return (
    <div
      className="relative hidden w-1/2 flex-col justify-between overflow-hidden p-12 text-white lg:flex"
      style={{
        background:
          "radial-gradient(120% 140% at 15% 10%, #3730A3 0%, transparent 55%), linear-gradient(160deg,#1E1B4B 0%,#312E81 45%,#4F46E5 100%)",
      }}
    >
      <WarehouseGridMotif />

      <div className="relative z-10">
        <div className="mb-7 flex items-center gap-2.5">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-white text-sm font-extrabold text-[#4338CA]">
            In
          </div>
          <div className="text-lg font-extrabold tracking-tight">Invyntra</div>
        </div>

        <div className="mb-4 inline-flex items-center rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-xs font-bold uppercase tracking-widest">
          {badge}
        </div>
        <h1 className="mb-2.5 max-w-md text-3xl font-extrabold leading-tight tracking-tight text-balance">
          {heading}
        </h1>
        <p className="max-w-sm text-sm leading-relaxed text-white/70">
          {subtext}
        </p>
      </div>

      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default AuthBrandPanel;
